import { tableStyle } from './table-style.js';

export default {
  install(Vue) {
    // table style方法
    Vue.mixin(tableStyle);
  }
};



// WEBPACK FOOTER //
// ./src/common/mixin/index.js